import { AxiosResponse } from 'axios';

import { CreateSignSS4RequestPayload, CreateSignSS4RequestResponse } from './useCreateSignSS4Request.interface';

import { sendDatadogRumError } from 'utils/analytics/datadogRum';
import collectiveApi from 'modules/common/collectiveApi';

const createSignSS4Request = async (payload: CreateSignSS4RequestPayload): Promise<CreateSignSS4RequestResponse> => {
    try {
        const response = await collectiveApi.post<
            CreateSignSS4RequestResponse,
            AxiosResponse<CreateSignSS4RequestResponse>,
            CreateSignSS4RequestPayload
        >('eSignSS4/', payload);
        return response.data;
    } catch (error) {
        sendDatadogRumError('createSignSS4Request', error, {
            context: 'createSignSS4Request',
            payload,
            url: 'eSignSS4/',
            flowName: 'entity-formation',
            taskName: 'sign',
        });
        throw error;
    }
};

export default createSignSS4Request;
